export { default } from './AboutInaAcc';
